import { render } from "./AuthRegistrationFlow.vue?vue&type=template&id=70b32429&scoped=true"
import script from "./AuthRegistrationFlow.vue?vue&type=script&lang=js"
export * from "./AuthRegistrationFlow.vue?vue&type=script&lang=js"

import "./AuthRegistrationFlow.vue?vue&type=style&index=0&id=70b32429&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b32429"]])

export default __exports__